import React from 'react'
import { Table, Button } from 'react-bootstrap'
import { currencyIcon } from '../../lib/AllStaticVariables'

const PricingCalculation = ({ calculation, setCalculation, fromPreview }) => {
  const updateIsOpen = (columnKey, isOpenValue) => {
    setCalculation((prevData) => {
      if (
        !prevData ||
        !prevData.displayCalculation ||
        !prevData.displayCalculation.customerPricing
      ) {
        console.error('Invalid state structure.')
        return prevData
      }

      return {
        ...prevData,
        displayCalculation: {
          ...prevData.displayCalculation,
          customerPricing: prevData.displayCalculation.customerPricing.map(
            (item) => {
              if (!item || !item.columns || !item.columns[columnKey]) {
                return item
              }

              return {
                ...item,
                columns: {
                  ...item.columns,
                  [columnKey]: {
                    ...item.columns[columnKey],
                    isOpen: isOpenValue
                  }
                }
              }
            }
          )
        }
      }
    })
  }

  return (
    <div className={fromPreview ? 'col-md-12 mt-2' : 'col-md-6'}>
      <div className='card'>
        <div className='card-body'>
          <h5 className='mb-3 head_h3'>Pricing Calculation</h5>

          {calculation?.displayCalculation?.customerPricing?.map(
            (pricingDetails) => (
              <Table
                className='table mb-0  table-hover pricing_table '
                key={Math.floor(Math.random() * 100000)}
              >
                <thead className='bg-default'>
                  <tr>
                    {pricingDetails?.heading?.values?.map((data) => (
                      <th
                        style={{ textTransform: 'capitalize' }}
                        key={Math.floor(Math.random() * 100000)}
                      >
                        {data?.replace('_', ' ')}
                        {data?.includes('details') ? '' : `(${currencyIcon})`}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className='bg-white'>
                  {Object.entries(pricingDetails?.columns)?.map(
                    ([key, value]) => (
                      <React.Fragment
                        key={Math.floor(Math.random() * 10000000)}
                      >
                        <tr
                          className={
                            key?.toLowerCase()?.includes('earn')
                              ? 'bg-default'
                              : ''
                          }
                          key={Math.floor(Math.random() * 100000)}
                        >
                          <td
                            className={
                              key?.toLowerCase()?.includes('mrp')
                                ? 'text-uppercase'
                                : 'text-capitalize'
                            }
                          >
                            <div className='d-flex gap-2'>
                              {value?.nested && (
                                <span
                                  role='button'
                                  onClick={() => {
                                    updateIsOpen(key, !value?.isOpen)
                                  }}
                                >
                                  <i
                                    className={`m-icon m-icon--${
                                      value?.isOpen ? 'remove' : 'plusblack'
                                    }`}
                                  ></i>
                                </span>
                              )}
                              <span>{key.replace('_', ' ')}</span>
                            </div>
                          </td>
                          {value?.values?.map((price) => (
                            <td key={Math.floor(Math.random() * 100000)}>
                              {price}
                            </td>
                          ))}
                        </tr>

                        {value?.nested &&
                          value?.isOpen &&
                          Object.entries(value?.nested)?.map(([key, value]) => (
                            <tr
                              className='position-relative pv-productd-remhover'
                              key={Math.floor(Math.random() * 100000)}
                            >
                              <td key={Math.floor(Math.random() * 100000)}>
                                {key}
                              </td>
                              {value?.values?.map((price) => (
                                <td key={Math.floor(Math.random() * 100000)}>
                                  {price}
                                </td>
                              ))}
                            </tr>
                          ))}
                      </React.Fragment>
                    )
                  )}
                </tbody>
              </Table>
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default PricingCalculation
